import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Card from '../../../shared/Card'
import IPCHeader from './instaPostCard/IPCHeader'
import IPCImage from './instaPostCard/IPCImage'
import IPCCaption from './instaPostCard/IPCCaption'
import IPCProductsTagged from './instaPostCard/IPCProductsTagged'

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: white;
`

const InstaPostCard = ({post, onClick, onChangeVisible, productsDict, productsTaggedAmount}) => {
  return (
    <Card
      width='277px'
      height='450px'
      key={post.id}
    >
      <Container>
        <IPCHeader
          isVisible={(post.disabled) ? !post.disabled : true}
          onClick={onClick}
          onChangeVisible={onChangeVisible}
        />
        <IPCImage
          image={post.imageMedium}
          onClick={onClick}
          productsTagged={productsTaggedAmount}
        />
        <IPCCaption
          caption={post.caption}
          onClick={onClick}
          date={post.createdTime}
          instaName={post.instaName}
        />
        <IPCProductsTagged
          productsDict={productsDict}
          products={post.products}
          onClick={onClick}
        />
      </Container>
    </Card>
  )
}


InstaPostCard.propTypes = {
  productsDict: PropTypes.object,
  post: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onChangeVisible: PropTypes.func,
  productsTaggedAmount: PropTypes.number
}

export default InstaPostCard



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/InstaPostCard.js